module.exports = __webpack_public_path__ + "static/media/installation outcome.e0a2ed3a.png";